export const PollingAlert = () => (
  <div className="bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-4 mb-4 text-sm" role="alert">
    <p className="font-bold">Megerősítésre várakozás...</p>
    <p>Kérjük, ellenőrizze az e-mail fiókját és kattintson a megerősítő linkre.</p>
  </div>
)
